// @flow
import { css } from "styled-components";

/*
 * This is a massive hack to get the PropositionSlide to always fill the full
 * width and height of the slick container, because it doesn't behave properly
 * with either position: absolute or height: 100% tricks
 */
export const desktopImageSizing = () =>
  css`
    width: 47.9vw;
    height: calc(47.9vw * (2 / 3));
    max-height: 433px;
    max-width: 650px;
  `;
